//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 15/08/2025
// Version : 1
// Description : Dialog para historial derivacon
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Dialog,
  List,
  ListItem,
  ListItemText,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Title from "../Title";
import moment from "moment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";

function Historial_derivaciones(props) {
  // para abrir
  const [abrirDialogHistorial, setAbrirDialogHistorial] = useState(
    props.abrirDialogHistorial
  );

  const [datosDerivacion, setDatosDerivacion] = useState(props.row);
  const [update, setUpdate] = useState(false);

  const [historial, setHistorial] = useState([]);

  const obtenerHistorial = () => {
    fetch(
      `${UrlApi}/viajes_abastecimiento_historial/historial/${datosDerivacion.id_viaje}`
    )
      .then((data) => data.json())
      .then((data) => setHistorial(data));
  };
  useEffect(() => {
    obtenerHistorial();
  }, []);

  const handleClose = () => {
    setAbrirDialogHistorial(!abrirDialogHistorial);
    if (props.onClose) {
      props.onClose();
    }
  };

  // console.log("HISTORIAL", historial);

  return (
    <div>
      <Dialog
        open={abrirDialogHistorial}
        onClose={handleClose}
        maxWidth="xs"
        //fullWidth
      >
        <Title titulo={`Historial de Derivaciones`} handleClose={handleClose} />
        <Box
          border={0.5}
          borderColor={grey[300]}
          backgroundColor="#F4F6F6"
          p={2}
          mt={1}
        >
          <Typography
            variant="body1"
            mb={2}
            fontWeight="bold"
            sx={{ textAlign: "center" }}
          >
            Viaje N° {datosDerivacion.id_viaje}
          </Typography>

          <Grid container spacing={2}>
            {historial.length > 0 ? (
              [...historial]
                .sort((a, b) => b.id_viaje_historial - a.id_viaje_historial)
                .map((h, index) => (
                  <Grid item xs={12} key={h.id_viaje_historial}>
                    <Box
                      p={1}
                      mb={1}
                      borderRadius={3}
                      border={1}
                      borderColor={grey[300]}
                      bgcolor="#ffffff"
                      boxShadow={5}
                      display="flex"
                      alignItems="center"
                      gap={3}
                    >
                      <LocationOnIcon color="primary" fontSize="large" />
                      <Box>
                        <Box display="flex" alignItems="center" gap={3}>
                          <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="primary.main"
                            sx={{ fontSize: 16 }}
                          >
                            {h.destino_derivacion}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body2"
                          color="body1"
                          fontWeight="bold"
                          sx={{ fontSize: 14 }}
                        >
                          {moment(h.fecha_derivacion).format("DD/MM/YYYY")}{" "}
                        </Typography>

                        <Typography
                          variant="caption"
                          color="body2"
                          display="block"
                          sx={{ fontSize: 14 }}
                        >
                          Derivó: <strong>{h.usuario_derivacion}</strong>
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))
            ) : (
              <Grid item xs={12}>
                <Typography variant="body2" color="textSecondary">
                  No hay derivaciones registradas
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Dialog>
    </div>
  );
}

export default Historial_derivaciones;
